import Base from './Base.js';
import Gateway from '../../Gateway.js';

export default class LastViewedVehicles extends Base {
  static get _path() {
    return 'es6/src/storage/models/LastViewedVehicles';
  }

  static get _defaultValue() {
    return [];
  }

  static add() {
    try {
      Gateway.autoRequire([this._path], (storageProvider) => {
        storageProvider.set(value);
      });
    } catch (e) {
      Gateway.window.console.warn(e);
    }
  }

  static getNumbers() {
    try {
      return this.provider.getNumbers();
    } catch (e) {
      Gateway.window.console.warn(e);
      return this._defaultValue;
    }
  }
}
